<template>
  <FastQuote/>
</template>

<script>
import FastQuote from '@/components/fast-quote/FastQuote.vue'

export default {

  name: 'Create',
  components: {
      FastQuote
  },
  mounted() {
    this.$store.dispatch('fetchAreas');
  }
}
</script>

<style>

</style>